<template>
  <button class="btn">
    <BaseIcon
      :icon="icon"
      class="btn__icon"
    />
  </button>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'
export default {
  name: 'BtnIcon',
  components: {
    BaseIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1000px;
  background: #222225;
  border: none;
  cursor: pointer;

  &__icon {
    color: #fff;
    width: 50%;
  }
}
</style>
